import { render, staticRenderFns } from "./ChatbotComponent.vue?vue&type=template&id=243075c0&"
import script from "./ChatbotComponent.vue?vue&type=script&lang=js&"
export * from "./ChatbotComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports